<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">{{$store.state.themeTitle}}室预约</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <el-tag>{{$refs.organDia?$refs.organDia.nodeArrName:''}}</el-tag>&nbsp;<el-button type="primary" @click="dialogOpen">选择</el-button>
        </el-form-item> -->
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" @focus="dialogOpen1" style="width:320px;"  @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_no" filterable clearable :placeholder="`请选择${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择状态">
            <el-option label="待审核" value="apply"></el-option>
            <el-option label="已通过" value="pass"></el-option>
            <el-option label="已拒绝" value="refuse"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">预约{{$store.state.themeTitle}}室</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column>
        <custom-table-column prop="status" label="状态" width="160" :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="预约人名称" width="120">
        </custom-table-column>
        <custom-table-column prop="order_user_name" label="工号" width="120">
        </custom-table-column>
        <custom-table-column prop="order_user_dep" label="预约人院系" width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="project_name" :label="`${$store.state.themeTitle}项目`" width="160">
        </custom-table-column>
        <custom-table-column prop="order_date" label="预约日期" width="160">
        </custom-table-column>
        <custom-table-column prop="phone" label="联系方式" width="135">
        </custom-table-column>
        <custom-table-column prop="section" label="预约节次" min-width="235">
        </custom-table-column>
        <custom-table-column prop="reason" label="预约事由" min-width="220">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleApply(scope.row.id,'pass')" v-if="scope.row.status=='apply'" type="text" size="small">通过</el-button>
            <el-button @click="handleApply(scope.row.id,'refuse')" v-if="scope.row.status=='apply'" type="text" size="small">拒绝</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisibleApply" width="400px">
      <span>{{applyContent}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleApply = false">取 消</el-button>
        <el-button type="primary" @click="updateApplyStatus">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan,mixinValidate,mixinFormatter],
  data() {
    
    return {
      classRooms: [],
      
      dialogVisibleApply: false,
      formInline: {
        training_no: '',
        status: '',
      },
      ruleForm: {
        order_user_dep: '',
        order_start: '',
        order_end: '',

        training_name: '',
        training_no: '',
        major: '',
        instrument_name: '',
        course_name: '',
      },
      ruleFormTep: {
        order_user_dep: '',
        order_start: '',
        order_end: '',

        training_name: '',
        training_no: '',
        major: '',
        instrument_name: '',
        course_name: '',
      },
      rules: {
        major: [{ required: true, message: '请输入专业', trigger: 'blur' }],
        order_user_dep: [{ required: true, message: '请输入预约人所在院系', trigger: 'blur' }],
        instrument_name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        course_name: [{ required: true, message: '请输入课程名称', trigger: 'blur' }],
        training_no: [{ required: true, message: `请选择`, trigger: 'change' }],

        phone: [{ required: true, message: '设备数量不能为空' , trigger: 'blur'},{ validator: this.checkphone , trigger: 'blur'}],
        order_start: [{ type: 'date', required: true, message: '请选择开始时间', trigger: 'change' }],
        order_end: [{ type: 'date', required: true, message: '请选择结束时间', trigger: 'change' }],
      },
      levell: [1, 2],
      organLabel: '',
      organLabel:'',
      type: 'add',
      tableName: '实训日志',
      applyContent: '',
      applyObj: {
        id: '',
        status: '',
      },
    };
  },
  created() {},
  mounted() {
    // this.getList();
    this.$store.dispatch('getTarinMent');
  },
  methods: {
    handleApply(id, status) {
      if (status == 'pass') {
        this.applyContent = '是否确认审批通过!';
      } else {
        this.applyContent = '是否确认审批拒绝!';
      }
      this.applyObj = {
        id: id,
        status: status,
      };
      this.dialogVisibleApply = true;
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    async updateApplyStatus() {
      let res = await this.$api.update.updateApplyStatus(this.applyObj);
      if (res.code == 0) {
        this.applyObj = {
          id: '',
          status: '',
        };
        this.$message.success('操作成功！');
        this.dialogVisibleApply = false;
        this.getList()

      }
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteMethod(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      if (params.order_start) {
        let timee = params.order_start.getTime() / 1000;
        params.order_start = this.$until.getTimeStr(timee, '-');
      }
      if (params.order_end) {
        let timee = params.order_end.getTime() / 1000;
        params.order_end = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.creat.createTrainroomApply(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      if (typeof params.order_start == 'string') {
        timee = new Date(params.order_start).getTime() / 1000;
        params.order_start = this.$until.getTimeStr(timee, '-');
      } else {
        timee = params.order_start.getTime() / 1000;
        params.order_start = this.$until.getTimeStr(timee, '-');
      }
      if (typeof params.order_end == 'string') {
        timee = new Date(params.order_end).getTime() / 1000;
        params.order_end = this.$until.getTimeStr(timee, '-');
      } else {
        timee = params.order_end.getTime() / 1000;
        params.order_end = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.update.updateMethod(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleQuery() {
      this.beforeQuery()
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getTrainTearchList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
